/**
 * Country metadata used by dashboard context controls.
 * `flagCode` maps to `public/images/icons/countries/<flagCode>.webp`.
 */
export const COUNTRY_METADATA = {
  AT: { labelKey: 'countries.at', flagCode: 'at' },
  BE: { labelKey: 'countries.be', flagCode: 'be' },
  CH: { labelKey: 'countries.ch', flagCode: 'ch' },
  CZ: { labelKey: 'countries.cz', flagCode: 'cz' },
  DE: { labelKey: 'countries.de', flagCode: 'de' },
  DK: { labelKey: 'countries.dk', flagCode: 'dk' },
  ES: { labelKey: 'countries.es', flagCode: 'es' },
  FI: { labelKey: 'countries.fi', flagCode: 'fi' },
  FR: { labelKey: 'countries.fr', flagCode: 'fr' },
  GB: { labelKey: 'countries.gb', flagCode: 'gb' },
  IT: { labelKey: 'countries.it', flagCode: 'it' },
  NL: { labelKey: 'countries.nl', flagCode: 'nl' },
  NO: { labelKey: 'countries.no', flagCode: 'no' },
  PL: { labelKey: 'countries.pl', flagCode: 'pl' },
  PT: { labelKey: 'countries.pt', flagCode: 'pt' },
  SE: { labelKey: 'countries.se', flagCode: 'se' },
  UK: { labelKey: 'countries.uk', flagCode: 'gb' },
};

const normalizeCountryCode = (value) => String(value || '').trim().toUpperCase();

export const getCountryMetadata = (countryCode) => {
  const normalizedCode = normalizeCountryCode(countryCode);
  const metadata = COUNTRY_METADATA[normalizedCode] || null;

  if (!metadata) {
    return {
      code: normalizedCode,
      labelKey: null,
      flagCode: normalizedCode.toLowerCase(),
      iconSrc: normalizedCode ? `/images/icons/countries/${normalizedCode.toLowerCase()}.webp` : null,
    };
  }

  return {
    code: normalizedCode,
    ...metadata,
    iconSrc: `/images/icons/countries/${metadata.flagCode}.webp`,
  };
};
